import { RouteConfig } from 'vue-router';
import SpogHomepage from './spog-homepage.vue';

export const SpogHomepageRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'spog-homepage',
  component: SpogHomepage,
};

export function getDefaultParams() {
  return {};
}

export default SpogHomepageRoute;
